import { createContext, ReactNode, useContext } from 'react'
import { FeatureFlags } from '../types'

type FliptContextValue = {
  flags: FeatureFlags
}

const FliptContext = createContext<FliptContextValue | null>(null)

type FliptProviderProps = {
  children: ReactNode
  ff: FeatureFlags
}

export const FliptProvider = ({ children, ff = {} }: FliptProviderProps) => {
  return (
    <FliptContext.Provider
      value={{
        flags: ff
      }}>
      {children}
    </FliptContext.Provider>
  )
}

export const useFliptContext = () => {
  const fliptContext = useContext(FliptContext)

  return fliptContext
}
